import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
export var ModalButtonsSection = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement("div", __assign({}, props, { className: cx('text-body mt-6', props.className) }), children));
};
